import BuyFirstShare from "./BuyFirstShare";

export default BuyFirstShare;
